import React, { useState, useEffect } from "react";
import { Stack } from "@fluentui/react";
import { Card, Text, CardHeader } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import "./CSS/QueueComponent.css";
const QueueComponent = (props) => {
  const [initQueueMetrics, setInitQueueMetrics] = useState({});
  const [agentStates, setAgentStates] = useState({});
  const { t } = useTranslation();
  // Fonction pour formater le temps en HH:mm:ss
  const formatTime = (seconds) => {
    if (!seconds || seconds <= 0) return "00:00:00";
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    return `${hrs.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };
// Date locale d'aujourd'hui au format YYYY-MM-DD
const now = new Date();
const dateTodayFormatted = now.getFullYear() + "-" +
  String(now.getMonth() + 1).padStart(2, "0") + "-" +
  String(now.getDate()).padStart(2, "0");

// Fonction utilitaire pour formater une date string en YYYY-MM-DD locale (nettoyage suffixe ordinal)
const formatDateStringToLocalYMD=(dateStr) =>{
  if (!dateStr) return null;
  // Nettoyer suffixes (1st, 2nd, 3rd, 4th...)
  const cleanedStr = dateStr.replace(/(\d+)(st|nd|rd|th)/, '$1');
  const parsedDate = new Date(cleanedStr);
  if (isNaN(parsedDate)) return null;

  return parsedDate.getFullYear() + "-" +
    String(parsedDate.getMonth() + 1).padStart(2, "0") + "-" +
    String(parsedDate.getDate()).padStart(2, "0");
}

  // Fonction pour formater les pourcentages
  const formatPercentage = (value) => {
    if (value == null || value === "--" || value === 0) return "--";

    // Convertir en nombre flottant
    const numberValue = parseFloat(value);

    // Si le nombre est entier, ne pas ajouter de chiffres après la virgule
    if (Number.isInteger(numberValue)) {
      return `${numberValue}%`;
    }

    // Sinon, fixer à deux chiffres après la virgule et supprimer les zéros inutiles
    const formattedValue = numberValue.toFixed(2).replace(/\.?0+$/, "");

    return `${formattedValue.replace(".", ",")}%`;
  };
  const formatPercentageOverflow = (value) => {
    if (value == null || value === "--" ) return "--";

    // Convertir en nombre flottant
    const numberValue = parseFloat(value);

    // Si le nombre est entier, ne pas ajouter de chiffres après la virgule
    if (Number.isInteger(numberValue)) {
      return `${numberValue}%`;
    }

    // Sinon, fixer à deux chiffres après la virgule et supprimer les zéros inutiles
    const formattedValue = numberValue.toFixed(2).replace(/\.?0+$/, "");

    return `${formattedValue.replace(".", ",")}%`;
  };
  // Calculer les statistiques de la file d'attente
  const calculateQueueMetrics = (queueData) => {
    const {
      calls,
      today,
      tasks,
      agentDetails,
      todayQueuedCalls,
      abandonedCall,
      queueFallback,
      slaReached,
      averageQueueingTime,
      longestWait,
      chatStats,
    } = queueData;
if(today){
  const formattedToday = formatDateStringToLocalYMD(today);

  if (!formattedToday || formattedToday !== dateTodayFormatted) {

    return {
      slaReachedChat: 0,
      abandonedCall: 0,
      queueFallback: 0,
      slaReached: 0,
      todayChats: 0,
      slaChat: 0,
      averageWaitTimeChat: 0,
      longestWaitChat: 0,
      callsInQueue: 0,
      tasksInQueue: 0,
      agentsReady: 0,
      longestWait: 0,
      todayCalls: 0,
      averageWaitTime: 0,
      abandonRate: 0,
      overflowRate: 0,
      sla: 0,
    };
  }
}
  

    const callsInQueue = Array.isArray(calls)
      ? calls.length
      : calls
      ? Object.keys(calls).length
      : 0;

    const agentsReady =
      agentDetails && typeof agentDetails === "object"
        ? Object.values(agentDetails).filter((agent) => agent.state === "READY")
            .length
        : 0;
    let todayChats = 0;
    let averageWaitTimeChat = 0;
    let longestWaitChat = 0;
    let slaChat = 0;
    let slaReachedChat = 0;
    // Check if chatStats exists and update the variables accordingly
    if (chatStats) {
      todayChats = chatStats.todayQueuedChats;
      averageWaitTimeChat = chatStats.averageWaitTime;
      longestWaitChat = chatStats.longestWait || 0;
      slaReachedChat = chatStats.slaReachedChat || 0;
      slaChat =
        chatStats.todayQueuedChats && slaReachedChat
          ? (slaReachedChat / chatStats.todayQueuedChats) * 100
          : 0;
    }

    return {
      slaReachedChat,
      abandonedCall,
      queueFallback,
      slaReached,
      todayChats,
      slaChat,
      averageWaitTimeChat,
      longestWaitChat,
      callsInQueue,
      tasksInQueue: tasks ? Object.keys(tasks).length : 0,
      agentsReady,
      longestWait: longestWait || 0,
      todayCalls: todayQueuedCalls || 0,
      averageWaitTime: averageQueueingTime || 0,
      abandonRate:
        todayQueuedCalls && abandonedCall
          ? (abandonedCall / todayQueuedCalls) * 100
          : 0,
      overflowRate:
        todayQueuedCalls && queueFallback
          ? (queueFallback / todayQueuedCalls) * 100
          : 0,
      sla:
        todayQueuedCalls && slaReached
          ? (slaReached / todayQueuedCalls) * 100
          : 0,
    };
  };

  const calculateAgentStates = (agents = {}, reasonCodes = []) => {
    const stateCounts = {
      READY: 0,
      "COFFEE BREAK": 0,
      "ADMIN WORK": 0,
      "OUT OF SHIFT": 0,
    };
  
  
    // Compter les reasonCodes
    reasonCodes.forEach((code) => {
      if (code) {
        if (!stateCounts.hasOwnProperty(code)) {
          stateCounts[code] = 1; // première occurrence
        } else {
          stateCounts[code]++; // répétition
        }
      }
    });
  
    // Compter les agent.state
    Object.values(agents).forEach((agent) => {
      const state = agent.state;
      if (state) {
        if (!stateCounts.hasOwnProperty(state)) {
          stateCounts[state] = 0;
        }
        stateCounts[state]++;
      }
    });
  
    return stateCounts;
  };
  

  useEffect(() => {
    if (props.signalRConnection) {
      const eventType = props.queue.id;
      // Initialiser les métriques et les états des agents
      setInitQueueMetrics(calculateQueueMetrics(props.queue));
      props.updateQueueMetrics(eventType, calculateQueueMetrics(props.queue));
      
      setAgentStates(calculateAgentStates(props.queue.agentDetails,   props.queue.reasonCodes ));
      props.updateAgentStates(
        eventType,
        calculateAgentStates(props.queue.agentDetails , props.queue.reasonCodes )
      );

      const onNotifReceived = (result) => {
  
        setInitQueueMetrics(calculateQueueMetrics(result));
        props.updateQueueMetrics(eventType, calculateQueueMetrics(result));
//&& result.reasonCodes
        if (result.agentDetails  ) {
          setAgentStates(calculateAgentStates(result.agentDetails , result.reasonCodes ));
          props.updateAgentStates(
            eventType,
            calculateAgentStates(result.agentDetails, result.reasonCodes )
          );
       
        }
      };
      // Écouter les événements SignalR
      props.signalRConnection.on(eventType, onNotifReceived);
    }
  }, [props.signalRConnection]);
  return (
    <div className="queue-container ">
      <CardHeader className="card-header" description={props.queue.queueName} />

      <Stack
        horizontal
        tokens={{ childrenGap: 5, padding: 5 }}
        styles={{
          root: {
            paddingLeft: 16, // remplace par la valeur que tu veux
            paddingRight: 16,
          },
        }}
      >
        {Object.entries(agentStates)
          .sort(([stateA], [stateB]) => {
            // Définir l'ordre des états connus
            const order = [
              "READY",
              "COFFEE BREAK",
              "ADMIN WORK",
              "OUT OF SHIFT",
            ];

            // Ajouter les reasonCodes uniquement s'ils existent
            if (
              Array.isArray(props.queue.reasonCodes) &&
              props.queue.reasonCodes.length > 0
            ) {
              order.push(...props.queue.reasonCodes);
            }

            return (
              (order.indexOf(stateA) === -1 ? 999 : order.indexOf(stateA)) -
              (order.indexOf(stateB) === -1 ? 999 : order.indexOf(stateB))
            );
          })
          .map(([state, count]) => {
            let colorClass = "color-unified";

            // Libellés personnalisés avec fallback
            const labels = {
              "COFFEE BREAK": t("QUEUES.COFFEE_BREAK"),
              "ADMIN WORK": t("QUEUES.ADMIN_WORK"),
              READY: t("QUEUES.READY"),
              "OUT OF SHIFT": t("QUEUES.OUT_OF_SHIFT"),
            };
            const label = labels[state] || state; // Utiliser l'état brut si non traduit

            return (
              <Card key={state} className={`agents-card ${colorClass}`}>
                <Text className="agents-card-text">{count}</Text>
                <Text className="agents-card-text">{label}</Text>
              </Card>
            );
          })}
      </Stack>
      {props.queue.channels.chat === true && (
        <Stack
          horizontal
          wrap
          tokens={{ childrenGap: 5, padding: 5 }}
          styles={{
            root: {
              paddingLeft: 10, // remplace par la valeur que tu veux
              paddingRight: 10,
            },
          }}
        >
          {[
            {
              label: t("QUEUES.INSTANT_MESSAGING"),
              value: initQueueMetrics.todayChats || 0,
              extra: t("QUEUES.CALLS_CHATS_EXTRA_TODAY"),
            },
            {
              label: t("QUEUES.INSTANT_MESSAGING"),
              value: initQueueMetrics.tasksInQueue || 0,
              extra: t("QUEUES.CALLS_CHATS_EXTRA_LIVE"),
            },
            {
              label: t("QUEUES.SLA"),
              value: formatPercentage(initQueueMetrics.slaChat) || "--",
            },
            {
              label: t("QUEUES.AVERAGE_WAIT_TIME"),
              value:
                formatTime(initQueueMetrics.averageWaitTimeChat) || "00:00:00",
            },
            {
              label: t("QUEUES.MAX_WAIT_TIME"),
              value: formatTime(initQueueMetrics.longestWaitChat) || "00:00:00",
            },
          ].map((metric, index) => (
            <Card key={index} className="queue-card-chat">
              <Text className="queue-card-text">{metric.value}</Text>
              <Text
                className={`queue-card-extra ${
                  metric.extra === "Live" ? "text-red" : "text-white"
                }`}
              >
                {metric.extra}
              </Text>
              <Text className="queue-card-text">{metric.label}</Text>
            </Card>
          ))}
        </Stack>
      )}
      <Stack
        horizontal
        wrap
        tokens={{ childrenGap: 5, padding: 5 }}
        styles={{
          root: {
            paddingLeft: 10, // remplace par la valeur que tu veux
            paddingRight: 10,
          },
        }}
      >
        {[
          {
            label: t("QUEUES.CALLS_IN_QUEUE"),
            value: initQueueMetrics.todayCalls || 0,
            extra: t("QUEUES.CALLS_CHATS_EXTRA_TODAY"),
          },
          {
            label: t("QUEUES.LIVE_CALLS"),
            value: initQueueMetrics.callsInQueue || 0,
            extra: t("QUEUES.CALLS_CHATS_EXTRA_LIVE"),
          },
          {
            label: t("QUEUES.ABANDON_RATE"),
            value: formatPercentage(initQueueMetrics.abandonRate) || "--",
          },
          {
            label: t("QUEUES.AVERAGE_WAIT_TIME"),
            value: formatTime(initQueueMetrics.averageWaitTime) || "00:00:00",
          },
          {
            label: t("QUEUES.MAX_WAIT_TIME"),
            value: formatTime(initQueueMetrics.longestWait) || "00:00:00",
          },
          {
            label: t("QUEUES.OVERFLOW"),
            value: formatPercentageOverflow(initQueueMetrics.overflowRate) ,
          },
          {
            label: t("QUEUES.SLA"),
            value: formatPercentage(initQueueMetrics.sla) || "--",
          },
        ].map((metric, index) => {
          const isSLA = metric.label === t("QUEUES.SLA");
          const slaColor =
            isSLA && metric.value !== "--"
              ? parseFloat(metric.value) > props.queue.slaThreshold
                ? "text-green"
                : "text-red"
              : "";

          return (
            <Card
              key={index}
              className={index === 0 ? "queue-card first-card" : "queue-card"}
            >
              <Text className={`queue-card-text ${slaColor}`}>
                {metric.value}
              </Text>
              <Text
                className={`queue-card-extra ${
                  metric.extra === "Live" ? "text-red" : "text-white"
                }`}
              >
                {metric.extra}
              </Text>
              <Text className="queue-card-text">{metric.label}</Text>
            </Card>
          );
        })}
      </Stack>
    </div>
  );
};

export default QueueComponent;
